import useSWR from "swr/immutable"

import { GET } from "~/api/_common/http"

import { defineFetcher } from "../_common/defineFetcher"

export type GetSkills = {
  skills: Array<string>
  error?: undefined
}

const PATH = "/skills"

export const fetchGetSkills = defineFetcher((): Promise<GetSkills> => {
  return GET(PATH)
})

export const useSWRForGetSkills = () => {
  return useSWR(PATH, fetchGetSkills)
}
